import pluralize from 'pluralize'

import { InherentRiskCategoryEnum, type Permission } from '@/gen/inventory/v1/company_service_pb'

import { stripPermissionPrefix } from '@/lib/string/string-utils'

import { PERMISSIONS_PREVIEW_COUNT } from '@/pages/company-drawer/company-overview/set-irq-modal/lema-suggestions-card/consts'

type PermissionsSummaryProps = {
  permissions: Permission[]
  answer: string
  categoryEnum: InherentRiskCategoryEnum
}

const verb = (form: string, subjectCount: number) => pluralize(form, subjectCount === 1 ? 2 : 1)

const phraseForCategory = (
  categoryEnum: InherentRiskCategoryEnum,
  answer: string,
  count: number,
) => {
  switch (categoryEnum) {
    case InherentRiskCategoryEnum.ATTACK_SURFACE:
      return `${verb('grants', count)} ${answer}, increasing your organization's attack surface exposure.`
    case InherentRiskCategoryEnum.DATA:
      return `${verb('allows', count)} to access ${answer}`
    default:
      return `allows ${answer}`
  }
}

export const PermissionsSummary = ({
  permissions,
  answer,
  categoryEnum,
}: PermissionsSummaryProps) => {
  const preview = permissions.slice(0, PERMISSIONS_PREVIEW_COUNT)
  const remaining = permissions.length - preview.length
  return (
    <p className='text-main-foreground-secondary text-body-small'>
      {pluralize('Permission', permissions.length)}{' '}
      {preview.map((p, i) => (
        <span key={`${p.name}-${i}`}>
          <code className='text-main-foreground-primary'>{stripPermissionPrefix(p.name)}</code>
          {i < preview.length - 1 ? ', ' : ''}
        </span>
      ))}
      {remaining > 0 && `, +${remaining} more`}{' '}
      {phraseForCategory(categoryEnum, answer, permissions.length)}
    </p>
  )
}
